import React from 'react';
import { Chip } from '@mui/material';
import { ExternalLeadStatus } from '@tassomutuo-backoffice/types';

interface IProps {
  status: ExternalLeadStatus;
}

const STATUS_LABEL: Record<ExternalLeadStatus, string> = {
  pending: 'In sospeso',
  'completed by user': 'Completata da utente',
  'completed by worker': 'Completata da worker',
};

const STATUS_COLOR: Record<
  ExternalLeadStatus,
  'default' | 'primary' | 'success' | 'warning' | 'info'
> = {
  pending: 'warning',
  'completed by user': 'success',
  'completed by worker': 'info',
};

const ExternalLeadStatusChip = ({ status }: IProps) => {
  return (
    <Chip
      size="small"
      label={STATUS_LABEL[status] ?? status}
      color={STATUS_COLOR[status] ?? 'default'}
      variant="outlined"
    />
  );
};

export default ExternalLeadStatusChip;
